module.exports = __webpack_public_path__ + "static/media/Inter.var-base.a64313bc.woff2";